if (!customElements.get('app-blog')) {
  customElements.define(
    'app-blog',
    class MainBlog extends HTMLElement {
      constructor() {
        super();

        this.filterPanel = this.querySelector('.filter-panel');
        this.sendSearch = document.querySelectorAll('.icon-search');

        const node = document.querySelector('div.top-preview');
        const offset = node.clientHeight - 60;

        if (this.sendSearch.length > 0) {
          this.sendSearch.forEach((element) => {
            element.addEventListener('click', (e) => {
              let form = e.target.closest('form');
              let input = form.querySelector('.input-search');
              if (input.value != '') {
                form.submit();
              } else {
                form.reportValidity();
              }
            });
          });
        }

        window.addEventListener('scroll', () => {
          if (
            window.pageYOffset <= offset ||
            document.documentElement.scrollTop <= offset
          )
            this.filterPanel.classList.remove('filter-fixed');
          if (
            window.pageYOffset > offset ||
            document.documentElement.scrollTop > offset
          ) {
            this.filterPanel.classList.add('filter-fixed');
            this.filterPanel.style.top = `${this.fixedTopDistance}px`;
          }
        });
      }
    },
  );
}
